import React from "react";
import BackBtn from "../../common/backBTN";

function RebateBouns() {
  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
  <div className="time-zone-container">
    <div className="time-zone-tips">
      <svg className="am-icon am-icon-warn_0e789534 am-icon-xs warn-icon"><use xlinkHref="#warn_0e789534" /></svg>
      {/* react-text: 738 */}Reminder: The data above is based on GMT + 8{/* /react-text */}
    </div>
    <div className="manual-rebate">
      <div className="mc-header-wrap">
        <div id="mc-header" className="mc-navbar-blue mc-manualRebate mc-default-header am-navbar am-navbar-light">
         <BackBtn/>
          <div className="am-navbar-title">Manual Rebate</div>
          <div className="am-navbar-right" />
        </div>
        <div className="am-whitespace am-whitespace-sm mc-whitespace" />
      </div>
      <div className="games" style={{height: '762.017px'}}>
        <div className="list-wrapper" style={{height: 'calc(100 * var(--vh, 1vh) - -43.01666259765625px)'}}>
          <ul className="scroll-inner-container" style={{transitionTimingFunction: 'cubic-bezier(0.165, 0.84, 0.44, 1)', transitionDuration: '0ms', transform: 'translate(0px) scale(1) translateZ(0px)'}}>
            <li>
              <div className="banner rebate bg-0">
                <div className="title">Date</div>
                <div className="money">2025-10-10</div>
              </div>
            </li>
            <li>
              <div className="banner rebate bg-1">
                <div className="title">Slot</div>
                <div className="money">0.0000</div>
              </div>
            </li>
            <li>
              <div className="banner rebate bg-2">
                <div className="title">Fish</div>
                <div className="money">0.0000</div>
              </div>
            </li>
            <li>
              <div className="banner rebate bg-3">
                <div className="title">Live</div>
                <div className="money">0.0000</div>
              </div>
            </li>
            <li>
              <div className="banner rebate bg-4">
                <div className="title">Sports</div>
                <div className="money">0.0000</div>
              </div>
            </li>
            <li>
              <div className="banner rebate bg-0">
                <div className="title">Poker</div>
                <div className="money">0.0000</div>
              </div>
            </li>
            <li>
              <div className="banner rebate bg-1">
                <div className="title">Lottery</div>
                <div className="money">0.0000</div>
              </div>
            </li>
            <li>
              <div className="banner rebate bg-2">
                <div className="title">Total</div>
                <div className="money">0.0000</div>
              </div>
            </li>
          </ul>
          <div className="ts-pulldown-wrapper">
            <div className="before-trigger">
              <div style={{textAlign: 'center'}}>
                <span className="activity-spinner">
                  <svg className="am-icon am-icon-spinner_7821ae30 am-icon-md"><use xlinkHref="#spinner_7821ae30" /></svg>
                </span>
                <span>Pull down to refresh</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-input-submit time-zone-space-p">
        <a role="button" className="btn-gray am-button am-button-disabled" aria-disabled="true"><span>Claim</span></a>
      </div>
    </div>
  </div>
</div>

  );
}

export default RebateBouns;